import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AuthToken } from './model/authToken';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { NcmImposto, NcmImpostoResponse } from './model/ncmImposto';

@Injectable({
  providedIn: 'root'
})
export class NcmImpostoService {
  constructor(private httpClient: HttpClient,
    private loginService: LoginService,
    private router: Router) { }

  servicePath: string = '/ipiAliqIcms'

  url:string = environment.apiUri + this.servicePath;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'x-access-token': this.loginService.getToken() })
  }

  
  get(id: number) : Observable<NcmImpostoResponse> {
    return this.httpClient.get<NcmImpostoResponse>(this.url + '?idIpi='+id, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  getById(id:number) : Observable<NcmImpostoResponse> {
    return this.httpClient.get<NcmImpostoResponse>(this.url + '/' + id, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  create(entity:NcmImposto) : Observable<any> {
    return this.httpClient.post(this.url, entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  update(entity:NcmImposto) : Observable<any> {
    return this.httpClient.put(this.url + '/' + entity.id,entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  delete(id:number) : Observable<any> {
    return this.httpClient.delete(this.url + '/' + id, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(error);
  };

}
